import React from 'react';
import { FiMail, FiSend } from 'react-icons/fi';

const Contact = () => {
  return (
    <section
      id="contact"
      className="w-full bg-gradient-to-b from-black to-gray-950 text-white py-24"
    >
      <div className="max-w-screen-lg mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-sm uppercase tracking-[0.25em] text-cyan-400 font-semibold mb-2">
              Contact
            </p>
            <h2 className="text-4xl sm:text-5xl font-bold">
              Let’s build something useful.
            </h2>
            <p className="mt-5 text-gray-400 text-lg leading-relaxed">
              Interested in backend, platform, cloud, or full-stack engineering
              opportunities? Send me a message.
            </p>
            <a
              href="mailto:ajitcpatil42@gmail.com"
              className="mt-6 inline-flex items-center gap-2 text-cyan-300 hover:text-cyan-200"
            >
              <FiMail /> ajitcpatil42@gmail.com
            </a>
          </div>

          <form
            action="https://getform.io/f/rbegwnmb"
            method="POST"
            className="rounded-2xl border border-white/10 bg-white/[0.035] p-6"
          >
            <label className="block text-sm text-gray-300 mb-2" htmlFor="name">
              Name
            </label>
            <input
              id="name"
              type="text"
              name="name"
              required
              placeholder="Your name"
              className="w-full rounded-lg border border-white/15 bg-black/30 p-3 text-white placeholder:text-gray-600 focus:border-cyan-400 focus:outline-none"
            />

            <label
              className="block text-sm text-gray-300 mt-5 mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              name="email"
              required
              placeholder="you@example.com"
              className="w-full rounded-lg border border-white/15 bg-black/30 p-3 text-white placeholder:text-gray-600 focus:border-cyan-400 focus:outline-none"
            />

            <label
              className="block text-sm text-gray-300 mt-5 mb-2"
              htmlFor="message"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              required
              placeholder="Tell me what you’d like to discuss"
              rows="7"
              className="w-full rounded-lg border border-white/15 bg-black/30 p-3 text-white placeholder:text-gray-600 focus:border-cyan-400 focus:outline-none"
            />

            <button className="mt-6 inline-flex items-center gap-2 rounded-lg bg-cyan-500 px-6 py-3 font-semibold text-black transition hover:bg-cyan-300">
              Send message <FiSend />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
